// A phone's reaction to one of our texts arrives as a text of its own:
// 'Loved “Twigs: Hi Aron…”' on older phones, '❤️ to “Twigs: Hi Aron…”' on newer
// ones. Turn it into something staff can read at a glance.

const WORDS = {
  liked: { emoji: '👍', label: 'Liked' },
  loved: { emoji: '❤️', label: 'Loved' },
  'laughed at': { emoji: '😂', label: 'Laughed at' },
  emphasized: { emoji: '‼️', label: 'Emphasized' },
  emphasised: { emoji: '‼️', label: 'Emphasized' },
  disliked: { emoji: '👎', label: 'Disliked' },
  questioned: { emoji: '❓', label: 'Questioned' },
};

const EMOJI_LABELS = {
  '👍': 'Liked',
  '👎': 'Disliked',
  '❤': 'Loved',
  '♥': 'Loved',
  '😂': 'Laughed at',
  '🤣': 'Laughed at',
  '‼': 'Emphasized',
  '❓': 'Questioned',
  '?': 'Questioned',
};

// Zero-width and direction marks phones wrap reactions in.
const INVISIBLE = /[​-‏⁠﻿]/g;
const WORD_FORM = /^(liked|loved|laughed at|emphasi[sz]ed|disliked|questioned)\s+[“"]\s*([\s\S]*?)[”"]?\s*$/i;
const EMOJI_FORM = /^(?:reacted\s+)?[“"]?(\S+?)[“"]?\s+to\s+(?:[“"]\s*([\s\S]*?)[”"]?|your message)\s*$/i;
const EMOJI_ONLY = /^\p{Extended_Pictographic}|^[?‼]/u;

/** Which of our texts the quote came from, in staff words. */
function textName(quoted) {
  const q = (quoted || '').toLowerCase();
  if (q.includes('on the way')) return 'the on-the-way text';
  if (q.includes('review')) return 'the review text';
  if (q.includes('ready for pickup') || q.includes('ready to pick up')) return 'the ready-for-pickup text';
  if (q.includes('delivered') || q.includes('left them') || q.includes('were left')) return 'the delivered text';
  return 'a text';
}

/**
 * @param {string} body  the customer's text as received
 * @returns {{emoji: string, label: string, quoted: string, target: string} | null}  null when it isn't a reaction
 */
export function describeTextReaction(body) {
  const text = String(body || '').replace(INVISIBLE, '').trim();

  const word = text.match(WORD_FORM);
  if (word) {
    const { emoji, label } = WORDS[word[1].toLowerCase()];
    const quoted = (word[2] || '').trim();
    return { emoji, label, quoted, target: textName(quoted) };
  }

  const emoji = text.match(EMOJI_FORM);
  if (emoji && EMOJI_ONLY.test(emoji[1])) {
    const base = emoji[1].replace(/[\u{1F3FB}-\u{1F3FF}️]/gu, '');
    const quoted = (emoji[2] || '').trim();
    return { emoji: emoji[1], label: EMOJI_LABELS[base] || 'Reacted to', quoted, target: textName(quoted) };
  }
  return null;
}

/** "Questioned the on-the-way text" — the reaction in a few words, no quote. */
export function reactionSentence(reaction) {
  return `${reaction.emoji} ${reaction.label} ${reaction.target}`;
}
